import cx from 'classnames';
import type { ReactNode } from 'react';

interface ListItemProps {
  counter?: ReactNode;
  isSelected: boolean;
  item: ListItemType;
  onClick?: () => void;
  stateIcon?: ReactNode;
}

export interface ListItemType {
  id: string;
  label: string;
}

const ListItem = (props: ListItemProps) => {
  const { counter, isSelected, item, onClick = () => false, stateIcon } = props;

  const classNames: string = cx(
    {
      'text-azure-base': isSelected,
      'text-navy-base hover:text-azure-base': !isSelected
    },
    'text-base xl:text-sm transition-all duration-200 ease-linear leading-normal',
    'flex justify-between min-w-60 max-w-[20rem] h-12 items-center py-1.5 pl-2 border-solid border-b border-grey-lighter cursor-pointer'
  );

  const activeIndicatorClassNames: string = cx(
    { 'bg-azure-base': isSelected, 'bg-transparent': !isSelected },
    'w-1 h-6 rounded-l transition-all duration-200 ease-linear'
  );

  return (
    <div className={classNames} data-testid="searchable-list-item" onClick={onClick}>
      <div className="flex items-center gap-2">
        <span className="flex ml-auto">{stateIcon}</span>
        <span>{item.label}</span>
      </div>

      <div className="flex items-center gap-2">
        <span className="flex ml-auto">{counter}</span>
        <div className={activeIndicatorClassNames} />
      </div>
    </div>
  );
};

export default ListItem;
